// Shared visibility helper cho AI Wizard / actionUpdateWithDoc.
//
// MOTIVATION: Trước đây 2 nơi check visibility KHÁC NHAU dẫn đến lệch:
//   • AntToolbar (actionUpdateWithDoc): chỉ check enabled + canAnalyze
//   • AntLeftSidebar (panel aiWizard): chỉ check enabled + whenSys use_Module_AIWithKey
//   → Case canAnalyze=false (vd voucher đã Close) → sidebar hiện, toolbar ẩn
//
// HỢP NHẤT 2 điều kiện (chính là logic của toolbar — reference baseline):
//   1. aiExtract.enabled — BE actionUpdatePrepare gắn flag này CHỈ KHI:
//        a) Service config configAIExtract (hasAIExtract())
//        b) Current AI source/quota permits voucher_analyzer (AntService.actionUpdatePrepare)
//        c) Voucher đã có id
//      → FE uses the server availability; legacy use_Module_AIWithKey is not the entitlement gate.
//      → Không cần check `hasAIExtract` ở FE — chỉ service hỗ trợ mới gửi flag.
//   2. aiExtract.canAnalyze !== false — state/quyền hiện tại cho phép phân tích.
//      BE set `canAnalyze = result.edit.isEditable !== false` — voucher Close/Cancel
//      có edit.isEditable=false → canAnalyze=false → ẩn cả 2.

function isAIWizardAvailable(aiExtract) {
    if (!aiExtract || !aiExtract.enabled) return false;
    if (aiExtract.canAnalyze === false) return false;
    return true;
}

export default { isAIWizardAvailable };
export { isAIWizardAvailable };
